import { Link } from "@tanstack/react-router";
import type { ListAlbumDto } from "@/lib/lutely-api/gen/dtos";
import { useLibrary } from "@/lib/lutely-api/hooks";
import { cn } from "@/lib/utils";
import HeartButton from "@/components/ui/HeartButton";

export type AlbumCardProps = {
  album: Pick<ListAlbumDto, "title" | "artworkUrl" | "creator"> & {
    albumId?: string;
  };
};

export default function AlbumCard({ album }: AlbumCardProps) {
  const { isAlbumSaved } = useLibrary();
  const saved = album.albumId ? isAlbumSaved(album.albumId) : false;

  const content = (
    <div
      data-scale-target
      className="transition-[transform,opacity] duration-150 ease-out"
    >
      <div className="group relative aspect-square overflow-hidden rounded-lg">
        {album.artworkUrl ? (
          <img
            src={album.artworkUrl}
            alt={album.title}
            className="h-full w-full object-cover"
            draggable={false}
          />
        ) : (
          <div className="h-full w-full bg-[#293737]" />
        )}

        {album.albumId && (
          <HeartButton
            kind="album"
            id={album.albumId}
            className={cn(
              "absolute !m-0 top-1 right-1 z-10 text-white drop-shadow-[0_1px_3px_rgba(0,0,0,0.6)] hover:bg-black/25 transition-opacity duration-200",
              !saved && "opacity-0 group-hover:opacity-100",
            )}
          />
        )}
      </div>
      <div className="mt-4 flex flex-col gap-2 text-center">
        <p className="truncate font-open-sans text-lg font-bold leading-[1.4] text-blue-900">
          {album.title}
        </p>
        <p className="truncate font-open-sans text-base font-semibold leading-[1.4] text-blue-900/70">
          {album.creator.stageName}
        </p>
      </div>
    </div>
  );

  if (album.albumId) {
    return (
      <Link
        to="/albums/$ALBUM_ID"
        params={{ ALBUM_ID: album.albumId }}
        className="block"
      >
        {content}
      </Link>
    );
  }

  return content;
}
